import * as React from 'react';
import styles from './index.less';
import * as ReactDOM from 'react-dom/client';
import FTerminatedContractListDrawer from './FTerminatedContractListDrawer';

interface fViewTerminatedContractsProps {
  terminatedContractIDs: string[];
}

type ReturnData = null;

function fViewTerminatedContracts({terminatedContractIDs}: fViewTerminatedContractsProps) {
  return new Promise<ReturnData>((resolve) => {
    const divRoot = self.document.body;
    const div = self.document.createElement('div') as HTMLDivElement;
    divRoot.appendChild(div);
    const root = ReactDOM.createRoot(div);

    return root.render(<FTerminatedContractListDrawer
      terminatedContractIDs={terminatedContractIDs}
      // onOk={() => {
      //   resolve(null);
      // }}
      onClose={() => {
        resolve(null);
        setTimeout(() => {
          root.unmount();
          div.remove();
        }, 300);
      }}
    />);
  });
}

export default fViewTerminatedContracts;
